module.exports = __webpack_public_path__ + "static/Abriss_Hotel-e231c89d1994af24562679f9c73e7439.png";